"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CtaContainer = exports.StyledMedia = exports.StyledColorPair = exports.TrainingCardContainer = exports.StyledTag = void 0;
const styles_1 = require("@mui/material/styles");
const tag_1 = __importDefault(require("../tag"));
const color_pair_1 = __importDefault(require("../color-pair"));
const media_1 = __importDefault(require("../media"));
const styles_2 = require("../tappable-card/styles");
exports.StyledTag = (0, styles_1.styled)(tag_1.default)({
    marginBottom: "16px"
});
exports.TrainingCardContainer = (0, styles_1.styled)("div")({
    backgroundColor: "unset",
    padding: 0,
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    height: "100%",
    color: "unset"
});
exports.StyledColorPair = (0, styles_1.styled)(color_pair_1.default)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    boxShadow: "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
    alignItems: "normal",
    textAlign: "initial",
    [`.${styles_2.classes.negative}`]: {
        marginTop: "-50px",
        "& svg, img": {
            backgroundColor: theme.colours.white
        }
    },
    [`.${styles_2.classes.text}`]: {
        marginTop: "18px",
        wordWrap: "break-word"
    },
    [`.${styles_2.classes.noBrandLogo}`]: {
        marginTop: 0
    }
}));
exports.StyledMedia = (0, styles_1.styled)(media_1.default)({
    height: "180px",
    opacity: 0.8,
    [`&.${styles_2.classes.contain}`]: {
        objectFit: "contain"
    }
});
exports.CtaContainer = (0, styles_1.styled)("div")({
    padding: "6px 30px 30px"
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RyYWluaW5nLWRldGFpbHMtY2FyZC9zdHlsZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUEsaURBQThDO0FBQzlDLGlEQUF5QjtBQUN6QiwrREFBc0M7QUFDdEMscURBQTZCO0FBQzdCLG9EQUFrRDtBQUVyQyxRQUFBLFNBQVMsR0FBRyxJQUFBLGVBQU0sRUFBQyxhQUFHLENBQUMsQ0FBQztJQUNuQyxZQUFZLEVBQUUsTUFBTTtDQUNyQixDQUFDLENBQUM7QUFFVSxRQUFBLHFCQUFxQixHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDO0lBQ2pELGVBQWUsRUFBRSxPQUFPO0lBQ3hCLE9BQU8sRUFBRSxDQUFDO0lBQ1YsVUFBVSxFQUFFLFlBQVk7SUFDeEIsT0FBTyxFQUFFLE1BQU07SUFDZixhQUFhLEVBQUUsUUFBUTtJQUN2QixRQUFRLEVBQUUsVUFBVTtJQUNwQixNQUFNLEVBQUUsTUFBTTtJQUNkLEtBQUssRUFBRSxPQUFPO0NBQ2YsQ0FBQyxDQUFDO0FBRVUsUUFBQSxlQUFlLEdBQUcsSUFBQSxlQUFNLEVBQUMsb0JBQVMsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUMvRCxPQUFPLEVBQUUsTUFBTTtJQUNmLGFBQWEsRUFBRSxRQUFRO0lBQ3ZCLEtBQUssRUFBRSxNQUFNO0lBQ2IsTUFBTSxFQUFFLE1BQU07SUFDZCxTQUFTLEVBQ1AsK0dBQStHO0lBQ2pILFVBQVUsRUFBRSxRQUFRO0lBQ3BCLFNBQVMsRUFBRSxTQUFTO0lBQ3BCLENBQUMsSUFBSSxnQkFBTyxDQUFDLFFBQVEsRUFBRSxDQUFDLEVBQUU7UUFDeEIsU0FBUyxFQUFFLE9BQU87UUFDbEIsWUFBWSxFQUFFO1lBQ1osZUFBZSxFQUFFLEtBQUssQ0FBQyxPQUFPLENBQUMsS0FBSztTQUNyQztLQUNGO0lBQ0QsQ0FBQyxJQUFJLGdCQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUNwQixTQUFTLEVBQUUsTUFBTTtRQUNqQixRQUFRLEVBQUUsWUFBWTtLQUN2QjtJQUNELENBQUMsSUFBSSxnQkFBTyxDQUFDLFdBQVcsRUFBRSxDQUFDLEVBQUU7UUFDM0IsU0FBUyxFQUFFLENBQUM7S0FDYjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxXQUFXLEdBQUcsSUFBQSxlQUFNLEVBQUMsZUFBSyxDQUFDLENBQUM7SUFDdkMsTUFBTSxFQUFFLE9BQU87SUFDZixPQUFPLEVBQUUsR0FBRztJQUNaLENBQUMsS0FBSyxnQkFBTyxDQUFDLE9BQU8sRUFBRSxDQUFDLEVBQUU7UUFDeEIsU0FBUyxFQUFFLFNBQVM7S0FDckI7Q0FDRixDQUFDLENBQUM7QUFFVSxRQUFBLFlBQVksR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUN4QyxPQUFPLEVBQUUsZUFBZTtDQUN6QixDQUFDLENBQUMifQ==